// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"circle"},"nodeName":"g","children":[{"attributes":{"id":"fill1","cx":12,"cy":12,"r":10,"fill":"transparent"},"nodeName":"circle","children":[]},{"attributes":{"id":"stroke1","cx":12,"cy":12,"r":10,"stroke":"currentColor","stroke-linecap":"square","stroke-width":2},"nodeName":"circle","children":[]}]}]};

@tag('t-icon-circle')
export default class CircleIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'circle',
    }
  }
}
